var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "no-chat-found-container" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "messages-content" }, [
      _vm._m(1),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "customer-page-button",
          on: { click: _vm.openCustomerPanel },
        },
        [
          _c("img", {
            staticClass: "message-img",
            attrs: { src: "/static/img/message-smile-square-svgrepo-com.svg" },
          }),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.$t("message.customerPage")))]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "live-support-image" }, [
      _c("img", { attrs: { src: "/static/img/liveSupportChat.svg" } }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "message-system" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v("Hiç aktif sohbet bulunamadı."),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "subtitle" }, [
        _vm._v(
          "Bu kısımda aktif sohbetler ve size atanan sohbetleri görebilirsiniz."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }